import { lazy } from "react";

const routes = [
  {
    path: "/settings/applications-modules",
    element: lazy(() => import("../../pages/Settings/ApplicationsModules")),
  },
];

export default routes;
